import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { UserService } from '@app/services/user/user.service';

@Component({
	selector: 'app-teams',
	templateUrl: './teams.component.html',
	styleUrls: ['./teams.component.css'],
})
export class TeamsComponent {
	accountUUID: string;
	temp = 'init';
	org_id: string;
	errorMessage: string;

	constructor(private router: Router, private userService: UserService) {
		this.errorMessage =
			'Something went wrong, we cannot complete your integration with Teams. ' +
			'Please contact us at support@zesty.co';
		this.userService.user$.pipe(filter(Boolean)).subscribe(() => {
			if (this.userService.organizationId) {
				this.org_id = this.userService.organizationId;
			}
			this.accountUUID = this.userService.userId;
		});
	}
}
